<button mat-stroked-button class="toolbar-action-btn" title="{{ (titleStringKey ? titleStringKey : '') | translate}}">

  <i *ngIf="iconClass" [class]="iconClass" class="btn-icon icomoon"></i>

  <span class="btn-text" *ngIf="titleStringKey">
    {{ titleStringKey | translate }}
  </span>

</button>
